import React from 'react';
import { usePage } from '../hooks/usePage';
import { SectionPreview } from '../components/sections/SectionPreview';
import { ErrorState } from '../components/ui/ErrorState';
import { EmptyState } from '../components/ui/EmptyState';
import { SEO } from '../components/shared/SEO';
import { PageSkeleton } from '../components/ui/Skeleton';
import { useTenant } from '../hooks/useTenant';

const ServiciosPage: React.FC = () => {
  const { page, loading, error, refetch } = usePage('servicios');
  const { config } = useTenant();

  // Estado de carga
  if (loading) {
    return <PageSkeleton message="Cargando servicios..." />;
  }

  // Estado de error
  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <ErrorState
          title="Error al cargar la página"
          message={error}
          onRetry={() => refetch()}
        />
      </div>
    );
  }

  // Si no hay página o no está publicada
  if (!page || page.status !== 'PUBLISHED') {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <EmptyState
          title="Página no disponible"
          message="La página de servicios no está disponible en este momento."
        />
      </div>
    );
  }

  // Si no hay secciones habilitadas
  if (!page.sections || page.sections.filter(s => s.enabled).length === 0) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <EmptyState
          title="Contenido no disponible"
          message="No hay contenido configurado para mostrar en esta página."
        />
      </div>
    );
  }

  return (
    <>
      <SEO
        title={page.seoTitle || page.title}
        description={page.seoDescription || page.description}
        keywords={page.seoKeywords}
        canonicalPath="/servicios"
        ogImage={page.ogImage}
      />
      <main className="min-h-screen">
        {/* Renderizar todas las secciones de la página dinámicamente */}
        {page.sections
          .filter(section => section.enabled)
          .sort((a, b) => a.order - b.order)
          .map((section) => (
            <SectionPreview
              key={section.id}
              section={section}
              isEnabled={section.enabled}
              viewport="desktop"
              tenantConfig={config}
            />
          ))}
      </main>
    </>
  );
};

export default ServiciosPage;
